import React from 'react';
import GivePage from './GivePage';

const BODY = `Pre-authorized giving lets you make a consistent monthly contribution directly from your bank account. It's the easiest way to support the ongoing mission of All Saints Catholic Parish and helps us plan and budget with confidence.

To enrol, please pick up an authorization form at the parish office or download it from the parish website. Complete the form, attach a void cheque, and return it to the office. Your monthly gift can be adjusted or paused at any time by contacting us.`;

const GiveAutomatic = () => (
  <GivePage
    slug="give-automatic"
    title="Automatic Debits"
    contentKey="give_automatic_body"
    defaultBody={BODY}
  />
);

export default GiveAutomatic;
